<script>
//Line, Bar, Pie, Doughnut, HorizontalBar, Bubble, Scatter, PolarArea
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    // this.chartData é criado no mixin.
    // Se você deseja passar opções, crie um objeto de opções locais
    this.renderChart(this.chartData, this.options);
  },
  
}
</script>


// WEBPACK FOOTER //
// src/views/Comum/Graficos/BarChart.vue